'use client'
import React, { useContext } from 'react';
import { MenuList } from '@/components/menuList';
import { Text } from '@chakra-ui/layout';
import { Icon, IconButton, Menu, MenuButton, MenuItem } from '@chakra-ui/react';
import { MdAdd, MdMoreHoriz, MdOutlineDelete } from 'react-icons/md';
import roleDictionnary from '@/lib/roleDictionnary';
import { useDisclosure } from '@chakra-ui/react-use-disclosure';
import { ProductContext } from '../../lib/productContext';
import DeleteProductModal from '../../components/deleteProductModal';
import { ProductPageContext } from '../lib/productPageContext';
import useTranslation from '../../../lib/i18n/useTranslation';
export default function ProductAsideEditMenu(props) {
  const { t } = useTranslation();
  const {
    product,
    role,
    rights,
  } = useContext(ProductContext);
  const {
    setEditingMainFeatures,
    setEditingTypes,
    setEditingValueProposition,
    setEditingUsefulLinks,
    sharedExperienceList,
    setAddingSharedExperience,
  } = useContext(ProductPageContext);
  const modalDelete = useDisclosure();
  return (
    <>
      {(product && (role && role !== roleDictionnary.viewer)) && (
        <>
          <Menu>
            {({ isOpen }) => (
              <>
                <MenuButton
                  isActive={isOpen}
                  as={IconButton}
                  icon={<MdMoreHoriz />}
                  variant='purpleOutline'
                />
                <MenuList>
                  {!product.value_proposition &&
                    <MenuItem onClick={() => {
                      setEditingValueProposition(true);
                    }}>
                      <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      {t('product.addValueProposition')}
                    </MenuItem>
                  }
                  {!product.types &&
                    <MenuItem onClick={() => {
                      setEditingTypes(true);
                    }}>
                      <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      {t('product.addProductTypes')}
                    </MenuItem>
                  }
                  {(!product.features || product.features.length === 0) &&
                    <MenuItem onClick={() => {
                      setEditingMainFeatures(true);
                    }}>
                      <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      {t('product.addMainFeatures')}
                    </MenuItem>
                  }
                  {(!sharedExperienceList || sharedExperienceList.length === 0) &&
                    <MenuItem onClick={() => {
                      setAddingSharedExperience(true);
                    }}>
                      <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      {t('product.addSharedExperience')}
                    </MenuItem>
                  }
                  {(!product.useful_links || product.useful_links.length === 0) &&
                    <MenuItem onClick={() => {
                      setEditingUsefulLinks(true);
                    }}>
                      <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      {t('product.addUsefulLinks')}
                    </MenuItem>
                  }
                  {rights.can_delete && (
                    <MenuItem onClick={() => {
                      modalDelete.onOpen();
                    }}>
                        <Icon
                        as={MdOutlineDelete}
                        color='text.medium.red'
                        boxSize={'14px'}
                        mr={2}
                      />
                      <Text color='text.medium.red' >{t('common.delete')}</Text>
                      <DeleteProductModal disclosure={modalDelete} />
                    </MenuItem>
                  )}
                </MenuList>
              </>
            )}
          </Menu>
        </>
      )}
    </>
  )
}
